import { message } from 'antd'
import { urgeNoticeLead } from '@services/lead/hotline'

/** 二次催促的二级意向 code（仅此场景表单提交后调用催办接口） */
export const SECOND_INBOUND_CODE = 'second inbound'

interface UrgeFormValues {
  uin?: string;
  company_name?: string;
  customer_intention?: string[];
  urge_notice?: boolean;
  urge_reason?: string;
}

/**
 * 表单提交成功后调用：仅在勾选催办且意向为「无需求-二次催促」时调用 UrgeNoticeLead。
 * 接口仅同步受理，失败不影响线索提交结果，也不重试。
 */
export async function sendUrgeNoticeLead (values: UrgeFormValues) {
  if (!values.urge_notice || values.customer_intention?.[1] !== SECOND_INBOUND_CODE) return
  const [, err] = await urgeNoticeLead({
    uin: (values.uin ?? '').trim(),
    customerName: (values.company_name ?? '').trim(),
    intentionLevel: values.customer_intention[0],
    intentionSecondLevel: values.customer_intention[1],
    urgeReason: (values.urge_reason ?? '').trim(),
  })
  if (err) {
    message.error(err.message || '催办请求失败，请稍后重试')
    return
  }
  message.success('催办请求已受理，结果以站内信告知')
}
